import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonButton from '../../../common/components/CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import RouterPaths from '../../../constants/RouterPaths';
import { useMediaQuery } from '../../../common/hooks/useMediaQuery';
import nextGearCapitalLogo from '../../../assets/img/nextGear/next-gear-logo.png';
import { NEXT_GEAR_CAPITAL_URL } from '../../constants';

function NextGearHeroSection() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleApplyNextGearClick = () => {
    window.open(NEXT_GEAR_CAPITAL_URL);
  };

  const handleStartFundingClick = () => {
    navigate(RouterPaths.LOGIN);
  };

  const alreadyCustomerCaption = isMobile
    ? 'Already a customer? Fund now'
    : 'Already a customer? Start funding now';

  return (
    <section className="ng-hero">
      <div className="ng-hero__inner">
        <h1 className="ng-hero__title">
          Fund Your <br /> Stock Vault Purchases <br />
          with NextGear Capital
        </h1>
        <h4 className="ng-hero__subtitle">
          Flexible stock funding now available directly on The Stock Vault.
        </h4>
        <div className="ng-hero__button-container">
          <CommonButton
            label="Apply with NextGear Capital"
            className="ng-hero__nextgear-button"
            variant={CommonButtonVariants.RED}
            handleClick={handleApplyNextGearClick}
            size="large"
          />
          <CommonButton
            label={alreadyCustomerCaption}
            className="ng-hero__funding-button"
            variant={CommonButtonVariants.OUTLINED_RED}
            handleClick={handleStartFundingClick}
            size="large"
          />
        </div>
        <img src={nextGearCapitalLogo} alt="NextGear Capital" className="ng-hero__logo" />
      </div>
    </section>
  );
}

export default NextGearHeroSection;
